const REGEX = /(\$\{)(.*)(\})/
export default {
  methods: {
    validate () {
      this.$refs[this._uid].$emit('submitEvent', this.modelProps)
    },
    expressionResolver (object) {
      let cloneObject = this._.cloneDeep(object)
      for (let key in cloneObject) {
        if (typeof cloneObject[key] === 'object') {
          cloneObject[key] = this.expressionResolver(cloneObject[key])
        } else {
          if (REGEX.test(cloneObject[key])) {
            let value = REGEX.exec(cloneObject[key])[2]
            try {
              // eslint-disable-next-line no-eval
              cloneObject[key] = eval(value)
            } catch (error) {
              console.log(error)
            }
          }
        }
      }
      return cloneObject
    }
  }
}
